export enum PackageGBCType {
  DEFAULT = 2072,
  INCLUDES_AIR_TICKETS = 2073,
}
